// extracted by mini-css-extract-plugin
export default {"container":"RF-z","disabled":"SF-z","bgBlack":"TF-z","content":"UF-z","countdown":"VF-z","topCaption":"WF-z","topHeading":"XF-z","heading":"YF-z","copy":"ZF-z"};